import { useDispatch, useSelector } from 'react-redux';

import Dropdown from 'atoms/dropdown';
import Input from 'atoms/input';
import { closeTimeHours, getOpenHours, prettifyHour } from 'util';

export default function AvailabilityRange({ day, range, editSlot }) {
  const dispatch = useDispatch();
  const locations = useSelector((state) => state.provider.locations);
  const providerLocation = locations[0];

  const openHours = () => {
    if (day) {
      const openHoursDay = providerLocation?.hours.filter(
        (hour) => hour.dow.value === day
      )[0];
      return getOpenHours(openHoursDay?.time) || [];
    }
    return [];
  };

  const editTime = (obj) => {
    const { start, end, uuid, date } = obj;
    dispatch(
      editSlot({
        day,
        obj,
        range,
        date,
        start: `${date}T${start}`,
        end: `${date}T${end}`,
        uuid,
      })
    );
  };

  // We display an input rather than just disabling the dropdown because
  // MUI dropdown is a pain and will complain about values not being inside the array of options.
  // Because this is a page heavy on dropdowns, the page becomes laggy. TODO: find a workaround for
  // MUI's issue
  return (
    <div className="flex-row w-100 availability-range">
      {!range.isPlaceholder ? (
        <>
          <Input
            variant="white"
            size="small"
            readOnly
            className="mr-10 w-100"
            value={range?.start ? prettifyHour(range.start) : ''}
          />
          <p className="f13">to</p>
          <Input
            variant="white"
            size="small"
            readOnly
            className="ml-10 w-100"
            value={range?.end ? prettifyHour(range.end) : ''}
          />
        </>
      ) : (
        <>
          <Dropdown
            variant="white"
            size="small"
            className="mr-10 w-100"
            placeholder="From"
            id="actions"
            value={range?.start ? prettifyHour(range.start) : null}
            items={openHours()}
            onClick={({ valueFormatted }) =>
              editTime({ ...range, start: valueFormatted })
            }
            disableDropdown={!range.isPlaceholder}
          />
          <p className="f13">to</p>
          <Dropdown
            variant="white"
            size="small"
            className="ml-10 w-100"
            placeholder="To"
            id="actions"
            value={range?.end ? prettifyHour(range.end) : null}
            items={closeTimeHours(
              { value: prettifyHour(range?.start) },
              openHours()
            )}
            onClick={({ valueFormatted }) =>
              editTime({ ...range, end: valueFormatted })
            }
            disableDropdown={!range.isPlaceholder}
          />
        </>
      )}
    </div>
  );
}
